import React, { useState } from "react";
import "./LatestUserScoresTable.css";

function LatestUserScoresTable({ scores }) {
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });

  const empathyScoreHighThreshold = 0.6;
  const empathyScoreLowThreshold = 0.3;

  const getScoreColor = (value) => {
    if (value > empathyScoreHighThreshold * 100) return "green";
    if (value < empathyScoreLowThreshold * 100) return "red";
    return "orange";
  };

  const sortData = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });

    const sorted = [...scores].sort((a, b) => {
      let valA, valB;

      if (key === "cognitive") {
        valA = a.cognitive_max ? a.cognitive / a.cognitive_max : 0;
        valB = b.cognitive_max ? b.cognitive / b.cognitive_max : 0;
      } else if (key === "affective") {
        valA = a.affective_max ? a.affective / a.affective_max : 0;
        valB = b.affective_max ? b.affective / b.affective_max : 0;
      } else if (key === "empathic") {
        valA = a.empathic_max ? a.empathic / a.empathic_max : 0;
        valB = b.empathic_max ? b.empathic / b.empathic_max : 0;
      } else if (key === "total_normalised") {
        valA = Number(a.total_normalised) || 0;
        valB = Number(b.total_normalised) || 0;
      } else {
        valA = a[key]?.toString().toLowerCase() || "";
        valB = b[key]?.toString().toLowerCase() || "";
        return direction === "asc"
          ? valA.localeCompare(valB)
          : valB.localeCompare(valA);
      }

      return direction === "asc" ? valA - valB : valB - valA;
    });

    // Update scores order for display
    setSortedScores(sorted);
  };

  const renderSortArrow = (column) => {
    if (sortConfig.key === column) {
      return sortConfig.direction === "asc" ? " ▲" : " ▼";
    }
    return "";
  };

  // Use local sorted state for display
  const [sortedScores, setSortedScores] = useState(scores);

  React.useEffect(() => {
    setSortedScores(scores);
  }, [scores]);

  return (
    <div className="table-wrapper">
      <table>
        <thead>
          <tr>
            <th onClick={() => sortData("username")}>
              Username{renderSortArrow("username")}
            </th>
            <th onClick={() => sortData("cognitive")}>
              Cognitive Empathy{renderSortArrow("cognitive")}
            </th>
            <th onClick={() => sortData("affective")}>
              Affective Empathy{renderSortArrow("affective")}
            </th>
            <th onClick={() => sortData("empathic")}>
              Empathic Responses{renderSortArrow("empathic")}
            </th>
            <th onClick={() => sortData("total_normalised")}>
              Total Normalised Score{renderSortArrow("total_normalised")}
            </th>
          </tr>
        </thead>
        <tbody>
          {sortedScores.map((score, index) => (
            <tr key={index}>
              <td>{score.username}</td>
              <td>
                {score.cognitive}/{score.cognitive_max} (
                <b style={{ color: getScoreColor(score.cognitive_max ? (score.cognitive / score.cognitive_max) * 100 : 0) }}>
                  {score.cognitive_max
                    ? ((score.cognitive / score.cognitive_max) * 100).toFixed(2)
                    : "0.00"}
                  %
                </b>
                )
              </td>
              <td>
                {score.affective}/{score.affective_max} (
                <b style={{ color: getScoreColor(score.affective_max ? (score.affective / score.affective_max) * 100 : 0) }}>
                  {score.affective_max
                    ? ((score.affective / score.affective_max) * 100).toFixed(2)
                    : "0.00"}
                  %
                </b>
                )
              </td>
              <td>
                {score.empathic}/{score.empathic_max} (
                <b style={{ color: getScoreColor(score.empathic_max ? (score.empathic / score.empathic_max) * 100 : 0) }}>
                  {score.empathic_max
                    ? ((score.empathic / score.empathic_max) * 100).toFixed(2)
                    : "0.00"}
                  %
                </b>
                )
              </td>
              <td>
                <b style={{ color: getScoreColor(Number(score.total_normalised)) }}>
                  {score.total_normalised !== undefined && score.total_normalised !== null
                    ? Number(score.total_normalised) === 0
                      ? "0.00"
                      : Number(score.total_normalised).toFixed(2)
                    : "0.00"}
                </b>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default LatestUserScoresTable;